<template>
  <div class="game-form-page">
    <!-- Back button -->
    <!-- <app-back-button
      route-name="SubprogramNba"
      :route-params="{ tabName: 'schedule' }"
      :i18nCode="`entities.subprogram.nba.tabs.schedule`"
    /> -->

    <app-back-button
      i18n-code="common.back.default"
    />
    <!-- Title -->
    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.game.edit.title" v-if="isEditing"></app-i18n>
      <app-i18n code="entities.game.new.title" v-if="!isEditing"></app-i18n>
    </h1>

    <div class="game-form-page__content app-content-page" v-loading="findLoading">

      <app-game-form-page-teams
        :homeTeam="get(record, 'homeTeam', {})"
        :awayTeam="get(record, 'awayTeam', {})"
        :isDisputedResult="isDisputedResult"
        :model="model"
      />
      
      <!-- Separator -->
      <div class="app-content-separator" />

      <!-- Subtitle -->
      <h2 class="app-content-subtitle">
        <app-i18n code="entities.game.subtitle.information" />
      </h2>

      <el-form
        v-loading="saveLoading"
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="game-form-page__content__form form"
        ref="form"
        v-if="model"
      >
        <el-row :gutter="10">
          <!-- Date -->
          <el-col :lg="6" :md="24" :sm="24">
            <el-form-item
              :label="fields.date.label"
              :prop="fields.date.name"
              :required="fields.date.required"
            >
              <!-- <el-date-picker
                v-model="model[fields.timestamp.name]"
                type="datetime"
                :placeholder="i18n('entities.game.placeholders.timestamp')"
              >
              </el-date-picker>-->
              <el-date-picker
                v-model="model[fields.date.name]"
                type="date"
                :placeholder="i18n('common.date.formatInput')"
                :format="dateFormat"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!-- Hour -->
          <el-col :lg="6" :md="24" :sm="24">
            <el-form-item
              :label="fields.hour.label"
              :prop="fields.hour.name"
              :required="fields.hour.required"
            >
              <el-time-picker
                :placeholder="i18n('entities.game.placeholders.hour')"
                v-model="model[fields.hour.name]"
                :format="timeFormat"
              ></el-time-picker>
            </el-form-item>
          </el-col>

          <!-- Location -->
          <el-col :lg="12" :md="24" :sm="24">
            <el-form-item
              :label="fields.location.label"
              :prop="fields.location.name"
              :required="fields.location.required"
            >
              <app-location-input
                v-model="model[fields.location.name]"
                :key="model.id"
                :placeholder="i18n('entities.game.placeholders.location')"
              />
            </el-form-item>
          </el-col>

          <!-- locationInfo -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.locationInfo.label"
              :prop="fields.locationInfo.name"
              :required="fields.locationInfo.required"
            >
              <el-input
                v-model="model[fields.locationInfo.name]"
                :placeholder="i18n('entities.game.placeholders.locationInfo')"
                prefix-icon="icon-file"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <div class="form-buttons">
            <el-button :disabled="saveLoading" @click="doBack" type="secondary">
              <app-i18n code="common.backButton" />
            </el-button>

            <el-button class="right" :disabled="saveLoading" @click="isDisputedResult ? openModal() : doSubmit()" type="primary">
              <app-i18n code="common.save"></app-i18n>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="back"
      class="game-form-page__modal"
      width="50%"
    >
      <div class="game-form-page__modal__contain">
        <!-- Icon -->
        <div 
          class="game-form-page__modal__contain__icon-circle"
          style="background-color: rgba(120, 139, 218, 0.2);"
        >
          <i 
            class="game-form-page__modal__contain__icon-circle__elem icon-info"
            style="color: #788bda;"
          />
        </div>

        <!-- Title -->
        <span 
          v-text="i18n('entities.subprogram.nba.alerts.results.title')"
          class="game-form-page__modal__contain__title"
        />

        <!-- Action text -->
        <span
          v-text="i18n('entities.subprogram.nba.alerts.results.action')"
          class="game-form-page__modal__contain__description"
        />

        <!-- Result + Teams logo -->
        <div class="game-form-page__modal__contain__results">

          <!-- Home Team Score -->
          <span
            v-if="model && model.homeTeamScore"
            v-text="model.homeTeamScore"
            class="game-form-page__modal__contain__results__home__score"
          />

          <!-- Home Team Image -->
          <img
            class="game-form-page__modal__contain__results__home__image"
            :src="homeTeamLogo"
          />

          <!-- VS -->
          <i class="game-form-page__modal__contain__results__vs icon-games" />

          <!-- Away Team Image -->
          <img
            class="game-form-page__modal__contain__results__away__image"
            :src="awayTeamLogo"
          />

          <!-- Away Team Score -->
          <span
            v-if="model && model.awayTeamScore"
            v-text="model.awayTeamScore" 
            class="game-form-page__modal__contain__results__away__score"
          />

        </div>

        <!-- Description text -->
        <span
          v-text="i18n('entities.subprogram.nba.alerts.results.description')"
          class="game-form-page__modal__contain__description"
        />

        <!-- Confirm button -->
        <el-button 
          class="game-form-page__modal__contain__confirm"
          type="primary"
          @click="doSubmit()"
        >
          <span v-text="i18n('common.confirm')"/>
        </el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { GameModel } from '@modules/game/game-model';
import { get, update } from 'lodash';
import { i18n } from '@shared/i18n';
import 'fix-date';
import moment from 'moment';
import TagsFactory from '@shared/factories/tags-factory';
import GameFormPageTeams from '@modules/game/components/game-form-page-teams.vue';

export default {
  name: 'app-game-form-page',

  props: {
    id: {
      type: String,
    },
    programId: {
      type: String,
    },
    subprogramId: {
      type: String,
    },
  },

  components: {
    [GameFormPageTeams.name]: GameFormPageTeams,
  },

  data() {
    return {
      model: null,
      dialogVisible: false,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'game/form/record',
      findLoading: 'game/form/findLoading',
      saveLoading: 'game/form/saveLoading',
      isRootScreen: 'layout/isRootScreen',
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    isDisputedResult() {
      if (this.model && this.model.status && this.model.status === 'disputedResult') return true
      else return false
    },
    
    isEditing() {
      return !!this.id;
    },

    subpropertyId() {
      return get(
        this,
        'currentManage.subproperty.id',
        null,
      );
    },

    homeTeamLogo() {
      return get(this, 'record.homeTeam.logo[0].publicUrl', '');
    },

    awayTeamLogo() {
      return get(this, 'record.awayTeam.logo[0].publicUrl', '');
    },

    rules () {
      const { formSchema } = this
      return formSchema.rules();
    },

    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.awayTeamScore,
        fields.homeTeamScore,
        fields.awayTeam,
        fields.homeTeam,
        fields.date,
        fields.hour,
        fields.location,
        fields.locationInfo,
        fields.status,
        fields.timestamp,
        fields.isTimeAssigned
      ]);
    },

    fields() {
      const { dateFormat, timeFormat } = this;
      return new GameModel({ dateFormat, timeFormat }).fields();
    },
  },

  async created() {
    const { formSchema } = this

    if (this.isEditing) {
      await this.doFind({
        id: this.id,
        subpropertyId: this.subpropertyId,
      });
    } else {
      await this.doNew();
    }
    this.model = formSchema.initialValues(this.record);

    this.model.hour = this.model.timestamp;
    this.model.date = this.model.timestamp;

    // 1. Update locationInfo with locationInfo
    const locationInfo = get(
      this,
      'model.location.information',
      '',
    );
    update(this, 'model.locationInfo', () => locationInfo);
  },

  methods: {
    ...mapActions({
      doFind: 'game/form/doFind',
      doNew: 'game/form/doNew',
      doUpdateCompetitionGame:
        'game/form/doUpdateCompetitionGame',
      doCreate: 'game/form/doCreate',
    }),

    doBack() {
      if (this.isRootScreen) {
        this.$router.push({
          name: 'SubprogramNba',
          params: {
            tabName: 'schedule',
          },
        });
      } else {
        this.$router.go(-1);
      }
    },

    doReset() {
      const { formSchema } = this
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      const { formSchema } = this; 
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      // 1. Update location.information with locationInfo
      const locationInfo = get(values, 'locationInfo', '');
      update(
        values,
        'location.information',
        () => locationInfo,
      );

      // 2. Update timestamp.information with date + hour,
      // and change the isTimeAssigned in function to have hour or not
      const date = get(values, 'date', '');
      const hour = get(values, 'hour', null);
  
      const dateMoment = moment(date);
      dateMoment.set('hour', 0);
      dateMoment.set('minute', 0);
      dateMoment.set('second', 0);

      const hoursMoment = moment(hour).hours();
      const minutesMoment = moment(hour).minutes();
      const secondsMoment = moment(hour).seconds();   

      const timestamp = dateMoment.add({
        hours: hoursMoment,
        minutes: minutesMoment,
        seconds: secondsMoment,
      });
      
      update(values, 'isTimeAssigned', () => !!hour);
      update(values, 'timestamp', () => timestamp);

      // 3. Refactor awayTeam, homeTeam
      update(values, 'awayTeam', () =>
        get(this, 'record.awayTeam.id', null),
      );
      update(values, 'homeTeam', () =>
        get(this, 'record.homeTeam.id', null),
      );

      // 4. Delete locationInfo from model
      delete values.locationInfo;

      // 5. Add program and subprogram
      update(values, 'program', () =>
        get(this, 'programId', null),
      );
      update(values, 'subprogram', () =>
        get(this, 'subprogramId', null),
      );

      if (this.isEditing) {
        await this.doUpdateCompetitionGame({
          id,
          values,
          subpropertyId: this.subpropertyId,
        });

        this.$router.push({
          name: 'SubprogramNba',
          params: {
            tabName: 'schedule',
            programId: this.programId,
            subprogramId: this.subprogramId,
          },
        });
      } else {
        return this.doCreate(values);
      }
    },

    i18n(code) {
      return i18n(code);
    },

    get(source, key, def) {
      return get(source, key, def);
    },

    getTagStyle(keyEnum, valueEnum) {
      const style = new TagsFactory({
        entityName: 'gameStatus',
      }).getTagStyle({
        keyEnum: keyEnum,
        valueEnum: valueEnum,
      });
      return style;
    },

    back() {
      this.dialogVisible = false;
    },

    openModal() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.game-form-page {
  &__content {
    padding: 56px 64px 0 64px;
  }

  &__modal__contain {
    padding: 0px 80px 40px 80px;
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 24px;
    justify-items: center;

    &__icon-circle {
      width: 76px;
      height: 76px;
      background: grey;
      display: grid;
      justify-items: center;
      align-items: center;
      border-radius: 50%;

      &__elem {
        font-size: 40px;
        justify-self: center;
      }
    }
    &__title {
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #686868;
      word-break: break-word;
    }
    &__results {
      width: 80%;
      display: grid;
      grid-template-areas: 'homeScore homeImg vs awayImg awayScore';
      align-items: center;
      padding: 16px 0px;
      &__home__score {
        grid-area: homeScore;
        justify-self: flex-end;
        color: #4e505e;
        font-size: 32px;
        font-weight: bold;
      }
      &__home__image {
        grid-area: homeImg;
        width: 80px;
        justify-self: flex-end;
      }
      &__vs {
        grid-area: vs;
        font-size: 40px;
        color: #cccccc;
        justify-self: center;
      }
      &__away__image {
        grid-area: awayImg;
        width: 80px;
        justify-self: flex-start;
      }
      &__away__score {
        grid-area: awayScore;
        color: #4e505e;
        font-size: 32px;
        font-weight: bold;
        justify-self: flex-start;
      }
    }
    &__description {
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #686868;
      word-break: break-word;
    }
    &__confirm {
      width: 211px;
      height: 38px;
      border-radius: 19px;
      background-color: #2acccc;
      color: #fff;
    }
  }

  .app-content-separator {
    margin: 40px 0;
  }
  .el-form {
    padding: 0;
    // padding: 0px 32px 20px 32px;
  }
}
</style>
